
export const SIGN_OUT = 'playerProfile.signOut';
export const signOut = () => ({ type: SIGN_OUT });
export const SIGN_OUT_SUCCESS = 'playerProfile.signOut.success';
export const signOutSuccess = () => ({ type: SIGN_OUT_SUCCESS });
